<template>
  <div>
    <ReportTable
      v-loading="tableLoading"
      :type="type"
      :title="title"
      :fields="fields"
      :items="items"
      :pageTotal="pageTotal"
      :currentPage="currentPage"
      :rows="rows"
      :path="path"
      :showHKSelect="false"
      :topExcel="true"
      :serverPagination="true"
      :stickyHeader="true"
      :optionsCriteria="optionsCriteria"
      :optionsGenre="optionsGenre"
      :optionsLevel="optionsLevel"
      :optionsVersion="optionsVersion"
      :optionsWeekday="optionsWeekday"
      :showExportText.sync="showExportText"
      :optionsOrigin="optionsOrigin"
      @handleSearch="handleSearch"
      @handleDateChange="handleDateChange"
      @handleCriteriaChange="handleCriteriaChange"
      @handleGenreChange="handleGenreChange"
      @handleLevelChange="handleLevelChange"
      @handleVersionChange="handleVersionChange"
      @handleOriginChange="handleOriginChange"
      @handleWeekdayChange="handleWeekdayChange"
      @handlePublicHolidayChange="handlePublicHolidayChange"
      @handleRunTypeChange="handleRunTypeChange"
      @handleWeekdayHolidayLogicChange="handleWeekdayHolidayLogicChange"
      @handleHolidayChange="handleHolidayChange"
      @handleMonthChange="handleMonthChange"
      @handleTheatreDayChange="handleTheatreDayChange"
      @pageChange="handlePageChange"
      @exportToExcel="exportToExcelFile()"
    />
    <el-dialog
      destroy-on-close
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="Excel Export"
      :visible.sync="exportDialog"
      width="30%"
    >
      <span>數據下載中，請勿離開...</span>
    </el-dialog>
  </div>
</template>
<script>
import ReportTable from './components/reportTable.vue'
import { getHighest, getHighestExport } from '@/api/specialRecord'
import { getGenreApi } from '@/api/film-material-management/genre'
import { getManageProperties } from '@/api/properties'
export default {
  name: 'ReportVersion',
  components: {
    ReportTable,
  },
  data() {
    return {
      exportDialog: false,
      showExportText: false,
      tableLoading: false,
      type: 'toprank',
      title: '22.5 最高排名',
      currentPage: 1,
      selectDropdown: true,
      path: 'special-film-record',
      // apiKey = 後端 order_by（表頭排序，見 docs/frontend-highest-handover-2026-09.md 第 4.2 節）；
      // sortDirection = 首次點該欄時的排序方向（數值／日期由高至低、文字由低至高）
      fields: [
        {
          key: 'name',
          label: '電影名稱',
          sortable: true,
          apiKey: 'film_name',
          sortDirection: 'asc',
        },
        {
          key: 'publisher',
          label: '發行商',
          sortable: true,
          apiKey: 'distributor',
          sortDirection: 'asc',
        },
        {
          key: 'film',
          label: '片種',
          sortable: true,
          apiKey: 'film_cat',
          sortDirection: 'asc',
        },
        {
          key: 'origin',
          label: '產地',
          sortable: true,
          apiKey: 'country',
          sortDirection: 'asc',
        },
        {
          key: 'level',
          label: '級別',
          sortable: true,
          apiKey: 'rating',
          sortDirection: 'asc',
        },
        {
          key: 'date_on',
          label: '上映日期',
          sortable: true,
          apiKey: 'date_release',
          sortDirection: 'asc',
        },
        {
          key: 'date_off',
          label: '落畫日期',
          sortable: true,
          apiKey: 'date_off',
          sortDirection: 'asc',
        },
        {
          key: 'first_day_bo',
          label: '首日票房',
          sortable: true,
          apiKey: 'first_day_bo',
          sortDirection: 'desc',
        },
        {
          key: 'visitors',
          label: '首日人次',
          sortable: true,
          apiKey: 'first_day_ad',
          sortDirection: 'desc',
        },
        {
          key: 'bo_first',
          label: '開畫首週票房',
          sortable: true,
          apiKey: 'first_week_bo',
          sortDirection: 'desc',
        },
        {
          key: 'first_week_visitors',
          label: '開畫首週人次',
          sortable: true,
          apiKey: 'first_week_ad',
          sortDirection: 'desc',
        },
        {
          key: 'single_day_highest_date',
          label: '最高單日日期',
          sortable: true,
          apiKey: 'highest_on_date',
          sortDirection: 'desc',
        },
        {
          key: 'single_day_highest',
          label: '最高單日票房',
          sortable: true,
          apiKey: 'highest_day_bo',
          sortDirection: 'desc',
        },
        {
          key: 'single_day_highest_visitors',
          label: '最高單日人次',
          sortable: true,
          apiKey: 'highest_day_ad',
          sortDirection: 'desc',
        },
        {
          key: 'bo_cummulative',
          label: '累積票房',
          sortable: true,
          apiKey: 'total_bo',
          sortDirection: 'desc',
        },
        {
          key: 'visit_cummulative',
          label: '累積人次',
          sortable: true,
          apiKey: 'total_ad',
          sortDirection: 'desc',
        },
        {
          key: 'highest_date_on_bo',
          label: '最高優先場票房',
          sortable: true,
          apiKey: 'highest_date_on_bo',
          sortDirection: 'desc',
        },
        {
          key: 'highest_date_on_ad',
          label: '最高優先場人次',
          sortable: true,
          apiKey: 'highest_date_on_ad',
          sortDirection: 'desc',
        },
      ],
      items: [],
      optionsCriteria: [
        { text: '首日票房', value: 'first_day_bo', key: 'first_day_bo' },
        { text: '首週票房', value: 'first_week_bo', key: 'bo_first' },
        {
          text: '最高單日票房',
          value: 'highest_day_bo',
          key: 'single_day_highest',
        },
        { text: '累積票房', value: 'total_bo', key: 'bo_cummulative' },
        { text: '首日人次', value: 'first_day_ad', key: 'visitors' },
        { text: '首週人次', value: 'first_week_ad', key: 'first_week_visitors' },
        {
          text: '最高單日人次',
          value: 'highest_day_ad',
          key: 'single_day_highest_visitors',
        },
        { text: '累積人次', value: 'total_ad', key: 'visit_cummulative' },
        {
          text: '最高優先場票房',
          value: 'highest_date_on_bo',
          key: 'highest_date_on_bo',
        },
        {
          text: '最高優先場人次',
          value: 'highest_date_on_ad',
          key: 'highest_date_on_ad',
        },
      ],
      // sort_type（榜單類型）由「搜尋條件」radio 決定；order_by / sort_dir 由表頭點擊決定
      sortParams: '&sort_type=total_bo&order_by=total_bo&sort_dir=desc',
      optionsWeekday: [
        { text: '星期一', value: '1' },
        { text: '星期二', value: '2' },
        { text: '星期三', value: '3' },
        { text: '星期四', value: '4' },
        { text: '星期五', value: '5' },
        { text: '星期六', value: '6' },
        { text: '星期日', value: '7' },
      ],
      selectedWeekday: '',
      selectedPublicHoliday: '',
      selectedWeekdayHolidayLogic: '',
      optionsGenre: [
        { text: '動作', value: '動作' },
        { text: '冒險', value: '冒險' },
        { text: '動畫', value: '動畫' },
        { text: '喜劇', value: '喜劇' },
        { text: '犯罪', value: '犯罪' },
        { text: '災難', value: '災難' },
        { text: '紀錄', value: '紀錄' },
        { text: '劇情', value: '劇情' },
        { text: '歷史', value: '歷史' },
        { text: '奇幻', value: '奇幻' },
      ],
      selectedGenre: '',
      optionsLevel: [],
      selectedLevel: '',
      optionsVersion: [],
      selectedVersion: '',
      optionsOrigin: [],
      selectedOrigin: '',
      selectedHoliday: '',
      selectedMonth: '',
      selectedTheatreDays: '',
      // 22.5：輪次口徑 —— selectedRunType 是 query string 片段（'' = 首映 = 不帶參數），
      // runTypeMode 只用來決定行上是否標示輪次
      selectedRunType: '',
      runTypeMode: 'first',
      pageTotal: 0,
      perPage: 5,
      // 22.5：per_page（後端預設 100、上限 500）
      rows: 100,
      search: '',
      startDate: '',
      endDate: '',
    }
  },

  watch: {
    '$store.state.app.areaChange': {
      handler(value) {
        this.resetPage()
        this.getReport()
      },
      deep: true,
    },
  },
  methods: {
    exportToExcelFile() {
      // 導出與屏幕同口徑：帶上目前的篩選與 sort_type / order_by / sort_dir（page / per_page 對導出無效）
      this.tableLoading = true
      const area = sessionStorage.getItem('area') || ''
      const data = `date_start=${this.startDate}&date_end=${this.endDate}${this.sortParams}${this.selectedRunType}${this.selectedWeekday}${this.selectedPublicHoliday}${this.selectedWeekdayHolidayLogic}${this.selectedGenre}${this.selectedLevel}${this.selectedVersion}${this.selectedOrigin}${this.selectedHoliday}${this.selectedMonth}${this.selectedTheatreDays}&export=1&area=${area}`
      getHighest(data)
        .then((res) => {
          this.getHighestExport(res.data.backlog)
        })
        .catch((error) => {
          this.tableLoading = false
        })
    },
    getHighestExport(backlog) {
      if (window.innerWidth < 1000) {
        this.showExportText = true
      } else {
        this.exportDialog = true
      }
      getHighestExport(backlog)
        .then((res) => {
          if (!res) {
            setTimeout(() => {
              this.getHighestExport(backlog)
            }, 5000)
          } else {
            const binaryData = []
            binaryData.push(res)
            const eLink = document.createElement('a')
            eLink.download =
              `Report Date/Time: ${this.$moment().format('YYYY-MM-DD/HH:mm')}` +
              '.xlsx'
            eLink.style.display = 'none'

            const blob = new Blob(binaryData, {
              type: 'application/vnd.ms-excel',
            })
            eLink.href = URL.createObjectURL(blob)
            document.body.appendChild(eLink)
            eLink.click()
            document.body.removeChild(eLink)
            this.exportDialog = false
            this.showExportText = false
            this.tableLoading = false
          }
        })
        .catch((error) => {
          this.showExportText = false
          this.exportDialog = false
          this.tableLoading = false
        })
    },
    exportToExcel() {
      //tabel list
      const header = []
      this.fields.map((el) => {
        header.push(el.label)
      })
      const dataList = []
      this.items.map((item) => {
        const distributors = []
        // if (item.distributor && item.distributor.length > 0) {
        //   item.distributor.map((distr) => {
        //     distributors.push(
        //       `${distr.distributor_name_zh_hk} ${distr.distributor_name_en}`
        //     );
        //   });
        // }
        // const company = [];
        // item.company.map((com) => {
        //   company.push(
        //     `${com.production_name_en}-${com.production_name_zh_hk}`
        //   );
        //  });
        const list = []
        list.push(
          item.name,
          item.publisher,
          item.film,
          item.origin,
          item.level,
          new Date(item.date_on),
          this.$moment(
            this.dateOffFormat(item.date_off, item.date_release)
          ).isValid()
            ? new Date(item.date_off)
            : this.dateOffFormat(item.date_off, item.date_release),
          Number(item.first_day_bo),
          Number(item.visitors),
          Number(item.bo_first),
          Number(item.first_week_visitors),
          new Date(item.single_day_highest_date),
          Number(item.single_day_highest),
          Number(item.single_day_highest_visitors),
          Number(item.bo_cummulative),
          Number(item.visit_cummulative),
          Number(item.highest_date_on_bo),
          Number(item.highest_date_on_ad)
        )
        dataList.push(list)
      })
      dataList.unshift(header)
      dataList.push([`Report Date/Time: ${this.$moment().format('YYYY-MM-DD/HH:mm')}`, ])
      const head1 = header.slice(7, 11)
      const head2 = header.slice(12, 18)
      const numFmt = head1.concat(head2)
      const numList = []
      numFmt.map((key) => {
        numList.push({
          title: this.getAlphabetLetter(header.indexOf(key)),
          index: 2,
        })
      })
      const excelInfo = {
        type: '22.5',
        merge: true,
        setDateValue: false,
        data: this.items,
        dateCol: [],
        fileName: `Top ranking B.O. Report (${this.startDate} to ${this.endDate}).xlsx`,
        header,
        excelData: dataList,
        numFmt: true,
        numFmtList: numList,
        hasTotal: false,
      }
      this.excelFun(excelInfo, 'noapi')
    },
    getManageProperties(type) {
      getManageProperties(type)
        .then((res) => {
          const arr = []
          if (type === 'film_rating') {
            res.data.map((el) => {
              arr.push({ text: el.name, value: el.name })
            })
            this.optionsLevel = arr
          } else if (type === 'film_visual_effect') {
            res.data.map((el) => {
              arr.push({ text: el.name, value: el.name })
            })
            this.optionsVersion = arr
          } else {
            res.data.map((el) => {
              if (!el.name.includes('/')) {
                const name =
                  type === 'film_country'
                    ? `${el.name_zh_hk} (${el.name_en})`
                    : el.name
                arr.push({ text: name, value: el.name })
              }
            })
            this.optionsOrigin = arr
          }
        })
        .catch(() => {
        })
    },
    // 任何篩選／排序變更都要把 page 歸 1（見 docs/frontend-highest-handover-2026-09.md 第 2 節）
    resetPage() {
      this.currentPage = 1
    },
    handlePageChange(page) {
      this.currentPage = page
      this.getReport()
    },
    handleDateChange(from, to) {
      this.startDate = from
      this.endDate = to
      this.resetPage()
    },
    // 「搜尋條件」radio：只更新查詢參數並把 page 歸 1，等使用者按 Search 才請求
    // （點表頭排序由 ReportTable 另外發 handleSearch 立即重查）
    handleCriteriaChange(val) {
      this.sortParams = val
      this.resetPage()
    },
    handleGenreChange(val) {
      this.selectedGenre = val
      this.resetPage()
    },
    handleLevelChange(val) {
      this.selectedLevel = val
      this.resetPage()
    },
    handleVersionChange(val) {
      this.selectedVersion = val
      this.resetPage()
    },
    handleOriginChange(val) {
      this.selectedOrigin = val
      this.resetPage()
    },
    handleWeekdayChange(val) {
      this.selectedWeekday = val
      this.resetPage()
    },
    handlePublicHolidayChange(val) {
      this.selectedPublicHoliday = val
      this.resetPage()
    },
    // 22.5：輪次口徑（run_type）。首映＝不帶參數（請求與改動前一致、命中同一份服務端緩存）
    handleRunTypeChange(val) {
      this.selectedRunType = val
      const matched = /run_type=([a-z]+)/.exec(val)
      this.runTypeMode = matched ? matched[1] : 'first'
      this.resetPage()
    },
    // 行鍵是 (film_master_id, run_ver_id)：重映／全部下同一部片會有多行，
    // film[] 的第一條不一定屬於本行輪次，必須按 run_ver_id 取（見 docs/frontend-highest-handover-2026-09.md 第 5.4 節）。
    // 取不到時退回第一條，避免欄位變空。
    pickRunFilm(row) {
      const films = (row.film_master && row.film_master.film) || []
      if (films.length === 0) {
        return {}
      }
      const matched = films.find(
        (film) => Number(film.run_ver_id) === Number(row.run_ver_id)
      )
      return matched || films[0]
    },
    handleWeekdayHolidayLogicChange(val) {
      this.selectedWeekdayHolidayLogic = val
      this.resetPage()
    },
    handleHolidayChange(val) {
      this.selectedHoliday = val
      this.resetPage()
    },
    handleMonthChange(val) {
      this.selectedMonth = val
      this.resetPage()
    },
    handleTheatreDayChange(val) {
      this.selectedTheatreDays = val
      this.resetPage()
    },
    handleLocationChange(val) {
      this.location = val
    },
    handleSearch(val) {
      this.resetPage()
      this.getReport()
    },
    getReport() {
      this.tableLoading = true
      const area = sessionStorage.getItem('area') || ''
      const data = `date_start=${this.startDate}&date_end=${this.endDate}${this.sortParams}${this.selectedRunType}${this.selectedWeekday}${this.selectedPublicHoliday}${this.selectedWeekdayHolidayLogic}${this.selectedGenre}${this.selectedLevel}${this.selectedVersion}${this.selectedOrigin}${this.selectedHoliday}${this.selectedMonth}${this.selectedTheatreDays}&page=${this.currentPage}&per_page=${this.rows}&area=${area}`
      getHighest(data)
        .then((res) => {
          const list = Array.isArray(res.data) ? res.data : []
          const arr = []
          const hasTotal = res.total !== undefined && res.total !== null
          const total = hasTotal ? Number(res.total) : list.length
          this.pageTotal = Number.isFinite(total) ? total : 0
          // page 超出末頁（例如改篩選後行數變少）時退回最後一頁重查，避免空白頁
          const maxPage = Math.max(1, Math.ceil(this.pageTotal / this.rows))
          if (this.currentPage > maxPage) {
            this.currentPage = maxPage
            this.getReport()
            return
          }
          this.items = arr
          list.forEach((el) => {
            const film_cat = []
            if (el.film_cat && el.film_cat.length > 0) {
              // const film_cat = [];
              el.film_cat.map((item) => {
                film_cat.push(item.filmcat_name_zh_hk)
              })
            }
            const obj = new Object()
            // 重映／全部下同一部片會有多行，行內的級別／上映／落畫必須取「本行輪次」的影片行
            const runFilm = this.pickRunFilm(el)
            obj.name = `${el.film_master.name_chinese} (${el.film_master.name_english})`
            // 同名多行無法分辨，於名稱後補上輪次（僅在非首映口徑下顯示）
            if (this.runTypeMode !== 'first') {
              const runLabel = el.run_ver_report || el.run_ver
              if (runLabel) {
                obj.name += ` 〔輪次 ${runLabel}〕`
              }
            }
            obj.publisher =
              el.distributor && el.distributor.length > 0
                ? `${el.distributor[0].distributor_name_zh_hk} (${el.distributor[0].distributor_name_en})`
                : '-'
            obj.film = film_cat.length > 0 ? film_cat.join(',') : '-'
            obj.origin = el.film_master.country
            obj.level = runFilm.rating

            obj.date_on = runFilm.date_release
            obj.date_off = runFilm.date_off
            obj.date_release = runFilm.date_release
            obj.first_day_bo = el.first_day_bo
            obj.visitors = el.first_day_ad
            obj.bo_first = el.first_week_bo
            obj.first_week_visitors = el.first_week_ad
            obj.single_day_highest_date = el.highest_on_date
            obj.single_day_highest = el.highest_day_bo
            obj.single_day_highest_visitors = el.highest_day_ad
            obj.bo_cummulative = el.total_bo
            obj.visit_cummulative = el.total_ad
            obj.highest_date_on_bo = el.highest_date_on_bo
            obj.highest_date_on_ad = el.highest_date_on_ad
            arr.push(obj)
          })
          this.items = arr
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    getGenreList() {
      const data = {
        page: 1,
        count: 1000,
      }
      getGenreApi(data)
        .then((res) => {
          this.optionsGenre = res.data
          const arr = []
          this.optionsGenre.forEach((el) => {
            const obj = new Object()
            obj.value = el.id
            obj.text = `${el.filmcat_name_zh_hk} (${el.filmcat_name_en})`
            arr.push(obj)
          })
          this.optionsGenre = arr
        })
        .catch(() => {
        })
    },
  },
  mounted() {
    if (!this.$route.query.startDate) {
      // const oneMonthAgoDate = new Date()
      // oneMonthAgoDate.setMonth(oneMonthAgoDate.getMonth() - 1)
      // this.startDate = oneMonthAgoDate.toISOString().slice(0, 10)
      this.startDate = this.$moment().subtract(1, 'months').format('YYYY-MM-DD')
    }
    if (!this.$route.query.endDate) {
      this.endDate = this.$moment().subtract(1, 'days').format('YYYY-MM-DD')
    }
    const manlist = ['film_rating', 'film_visual_effect', 'film_country']
    manlist.map((el) => {
      this.getManageProperties(el)
    })
    // this.getReport()
    this.getGenreList()
  },
}
</script>
